import React from 'react'
import Router from './components/layout/router'

const App = () => <Router />

export default App
